

exports.__esModule = true;
exports.$xoNbrDEPageRoute = undefined;

var _index = require('squid/index');

var _directive = require('./directive');

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoNbrDEPageRoute = exports.$xoNbrDEPageRoute = _index.$Route.extend('$xoNbrDEPageRoute', {

    path: 'negativeBalanceRecovery',
    directive: _directive2['default'],
    // titleContent: 'nbr.title',

    // trackingData: {
    //     fptiState: 'econsent',
    //     templateName: 'eConsent.dust',
    //     pageGoal: 'eConsent',
    //     buzname: {
    //         'fullpage': {
    //             'pagename': '%::fullpage-econsent',
    //             'pagename2': '%::fullpage-econsent:member:hermes:',
    //             'version': 'member:%:'
    //         }
    //         // More page qualifiers come here...
    //     }
    // },

    children: []
});

angular.value("$xoNbrDEPageRoute", $xoNbrDEPageRoute);
_index.$Route;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-nbr/route.js
// module id = ./pages/xo-nbr/route.js
// module chunks = 0